import { motion } from "framer-motion";
import { Plus } from "lucide-react";
import { fadeUp, stagger } from "./motion";
import { ASSETS, SHAKE_ADDONS, openOrder } from "../../data/site";

export const Shakes = () => {
  return (
    <section id="shakes" data-testid="shakes-section" className="relative bg-[#E6FBF3] overflow-hidden">
      <div className="blob bg-[#FFD1E4] w-[360px] h-[360px] -bottom-24 -left-16 opacity-70" />
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 py-20 sm:py-28 relative">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <motion.div variants={fadeUp} initial="hidden" whileInView="show" viewport={{ once: true }} className="relative">
            <img src={ASSETS.shakesCups} alt="Cookies & cream and strawberry premium shakes" loading="lazy"
              className="w-full aspect-[4/5] object-cover rounded-[2.5rem] border-4 border-white shadow-[0_40px_80px_-30px_rgba(18,185,155,0.55)]" />
          </motion.div>

          <div>
            <motion.span variants={fadeUp} initial="hidden" whileInView="show" viewport={{ once: true }}
              className="eyebrow text-[#F63C8B]">Premium</motion.span>
            <motion.h2 variants={fadeUp} custom={1} initial="hidden" whileInView="show" viewport={{ once: true }}
              className="font-display mt-3 text-[clamp(2rem,5vw,3.75rem)] leading-[1.02] text-[#2A1620]">
              Handcrafted <span className="font-script text-[#12B99B]">Shakes</span>
            </motion.h2>
            <motion.p variants={fadeUp} custom={2} initial="hidden" whileInView="show" viewport={{ once: true }}
              className="mt-5 text-[#5E4A54] leading-relaxed max-w-lg">
              Thick, dreamy shakes blended from our signature rolled ice cream flavors — then loaded up
              exactly how you like them. Customize every sip.
            </motion.p>

            <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={{ once: true }}
              className="mt-7 flex flex-wrap gap-2.5">
              {SHAKE_ADDONS.map((a) => (
                <motion.span key={a} variants={fadeUp} data-testid={`shake-addon-${a}`}
                  className="inline-flex items-center gap-1.5 rounded-full bg-white border border-[#CDEFE5] hover:border-[#12B99B] text-[#3A2A32] text-sm px-4 py-2 shadow-[0_8px_18px_-14px_rgba(18,185,155,0.7)] transition-colors">
                  <Plus size={13} className="text-[#12B99B]" /> {a}
                </motion.span>
              ))}
            </motion.div>

            <motion.button variants={fadeUp} custom={3} initial="hidden" whileInView="show" viewport={{ once: true }}
              onClick={openOrder} data-testid="shakes-order"
              className="btn-primary mt-9 inline-flex px-8 py-4 text-sm font-bold uppercase tracking-[0.12em]">
              Build Your Shake
            </motion.button>
          </div>
        </div>
      </div>
    </section>
  );
};
